import {
  http
} from '../../config';
import base from '../base';

export const classStatisticPage={
  getClassPageList(data){
    return http({
      url:`${base.users}/teacherProxy/queryClassStatisticsPageList`,
      method:'post',
      data,
    });
  },
  getClassPageDetailList(data){
    return http({
      url:`${base.users}/teacherProxy/queryClassStatisticsDetailInformationList`,
      method:'post',
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/agent-api/classStatisticPage.js